// import { Stack } from "@mui/system";
// import React, { useState } from "react";
// import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import logo_white from "../../assets/logo_white.png";
// import "./auth.css";
// import { useDispatch } from "react-redux";
// import { login_service_auth } from "../../store/services/authentication";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();
//     setError("");

//     // Validation
//     if (!email || !password) {
//       setError("All fields are required.");
//       return;
//     }

//     if (!validateEmail(email)) {
//       setError("Invalid email format.");
//       return;
//     }

//     // Prepare data for API
//     const loginData = {
//       email: email.trim(),
//       password: password.trim(),
//       //   role: "Admin",
//     };

//     console.log("Sending data to API:", loginData);

//     dispatch(login_service_auth(loginData));

//     // navigate("/dashboard");
//   };

//   return (
//     <Stack bgcolor={"gray"} className="bgImageSignup" gap={40}>
//       <Stack>
//         <Grid container>
//           <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
//             <Stack
//               ml={{ xs: "15%", sm: "15%", md: "28%", lg: "28%", xl: "35%" }}
//               mt={5}
//             >
//               <Stack>
//                 <img
//                   src={logo_white}
//                   width={"100%"}
//                   style={{ maxWidth: "120px" }}
//                   alt="Logo"
//                 />
//               </Stack>
//             </Stack>
//             <Stack
//               alignItems={"center"}
//               justifyContent={"center"}
//               width={"100%"}
//             >
//               <Stack
//                 alignItems={"center"}
//                 justifyContent={"center"}
//                 width={"100%"}
//               >
//                 <div className="login-container">
//                   <Stack my={6}>
//                     <h1 style={{ fontSize: "50px" }}>Login</h1>
//                     <p className="mainPara">
//                       Please login to continue your account.
//                     </p>
//                   </Stack>
//                   {error && (
//                     <p style={{ color: "red" }} className="error-text">
//                       {error}
//                     </p>
//                   )}
//                   <form onSubmit={handleLogin}>
//                     <label>Email</label>
//                     <input
//                       type="email"
//                       placeholder="test@email.com"
//                       autoComplete="off"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       required
//                     />
//                     <label>Password</label>
//                     <input
//                       type="password"
//                       placeholder="********"
//                       autoComplete="off"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                     />
//                     <div className="login-options">
//                       <a
//                         onClick={() => navigate("/forgot-password")}
//                         className="forgot-password"
//                       >
//                         Forgot Password?
//                       </a>
//                     </div>
//                     <button type="submit" className="login-button">
//                       Login
//                     </button>
//                   </form>
//                   <p className="signup-text">
//                     New User?{" "}
//                     <a
//                       onClick={() => navigate("/signup")}
//                       className="signup-link"
//                     >
//                       Sign up now
//                     </a>
//                   </p>
//                 </div>
//               </Stack>
//             </Stack>
//           </Grid>
//         </Grid>
//       </Stack>
//     </Stack>
//   );
// };

// export default Login;


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login_service_auth } from "../../store/services/authentication";
import { asyncStatus } from "../../utils/contants/asyncStatus";

const Login = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();


  const { user_login_status, user_login_error } = useSelector((state) => state.userAuth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  
  const handleLogin = () => {
    const obj = {
      email: email,
      password: password,
    };
    dispatch(login_service_auth(obj));


  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-center text-gray-700">Login</h2>
        <div className="mt-4">
          <label className="block text-gray-600">Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full mt-2 p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
          />
        </div>
        <div className="mt-4">
          <label className="block text-gray-600">Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full mt-2 p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
          />
        </div>
        {user_login_error?.message && (
          <p className="mt-4 text-sm text-red-500 text-center bg-red-50 border border-red-200 rounded-lg p-3">
            {user_login_error.message}
          </p>
        )}
        <button
          onClick={handleLogin}
          className="w-full mt-6 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-3 rounded-lg flex justify-center items-center transition duration-300"
          disabled={user_login_status === asyncStatus.LOADING}
        >
          {user_login_status === asyncStatus.LOADING ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-white"></div>
          ) : (
            "Login"
          )}
        </button>
      </div>
    </div>
  );
};

export default Login;